import type {
  Feature,
  FeatureCollection,
  GeoJsonProperties,
  Geometry,
  GeometryCollection
} from "geojson";

import { SpatialAggregationType } from "./common";
import { EOutputAnalysisType } from "./spatial";

export enum MapSource {
  MAPBOX = "mapbox",
  STYLE_URL = "style-url"
}

export enum MapProvider {
  MAPBOX = "mapbox",
  CARTO = "carto"
}

export enum LayerType {
  POINT = "poi",
  POLYGON = "polygon",
  ADMINISTRATIVE = "adm_area",
  GRID = EOutputAnalysisType.GRID,
  PROFILING = EOutputAnalysisType.PROFILING,
  H3 = "H3",
  GEOHASH = "geohash",
  LINE = "line"
}
export interface FeatureDataConfig {
  type: SpatialAggregationType;
  data: Feature<Geometry> | FeatureCollection;
  sublayers?: {
    [key: string]: string;
  };
}

export interface SelectedFeature {
  source: string;
  id: number | string;
  properties: GeoJsonProperties;
  geometry: Exclude<Geometry, GeometryCollection>;
}

export interface ClusterConfig {
  id: number | string;
  color?: string;
  radius?: number;
}

// Configuration interface
export interface MapConfig {
  provider: MapProvider;
  styleUrl: string;
  attribution: string;
  mapboxAccessToken?: string;
}

export interface MarkerPinItem {
  lng: number;
  lat: number;
  locationName?: string;
  id: string;
}

export interface MapStyleProperties {
  color?: string;
  weight?: number;
  opacity?: number;
  fillColor?: string;
  fillOpacity?: number;
  visibility?: "visible" | "none";
  lineColor?: string;
  lineWidth?: number;
}

export interface FeatureOptions {
  type: "Feature";
  geometry: {
    type: "Polygon";
    coordinates: number[][]; // Crucial: Array of rings (array of Position)
  };
}

export type BoundingBox = [number, number, number, number];
